import { render, staticRenderFns } from "./siteDocCard.vue?vue&type=template&id=ca5fcbd2&"
import script from "./siteDocCard.vue?vue&type=script&lang=js&"
export * from "./siteDocCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports